export default "__VITE_ASSET__CDZK_UCS__"